// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Telescope,
    Tent,
    TentTree,
    Terminal,
    TestTube,
    TestTubeDiagonal,
    TestTubes,
    TextAlignCenter,
    TextAlignEnd,
    TextAlignJustify,
    TextAlignStart,
    TextCursor,
    TextCursorInput,
    TextInitial,
    TextQuote,
    TextSearch,
    TextWrap,
    Theater,
    Thermometer,
    ThermometerSnowflake,
    ThermometerSun,
    ThumbsDown,
    ThumbsUp,
    Ticket,
    TicketCheck,
    TicketMinus,
    TicketPercent,
    TicketPlus,
    TicketSlash,
    TicketX,
    Tickets,
    TicketsPlane,
    Timeline,
    Timer,
    TimerOff,
    TimerReset,
    ToggleLeft,
    ToggleRight,
    Toilet,
    ToolCase,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "telescope" through "tool-case", inclusive. */
const shard: Record<string, LucideIcon> = {
    telescope: Telescope,
    tent: Tent,
    "tent-tree": TentTree,
    terminal: Terminal,
    "test-tube": TestTube,
    "test-tube-diagonal": TestTubeDiagonal,
    "test-tubes": TestTubes,
    "text-align-center": TextAlignCenter,
    "text-align-end": TextAlignEnd,
    "text-align-justify": TextAlignJustify,
    "text-align-start": TextAlignStart,
    "text-cursor": TextCursor,
    "text-cursor-input": TextCursorInput,
    "text-initial": TextInitial,
    "text-quote": TextQuote,
    "text-search": TextSearch,
    "text-wrap": TextWrap,
    theater: Theater,
    thermometer: Thermometer,
    "thermometer-snowflake": ThermometerSnowflake,
    "thermometer-sun": ThermometerSun,
    "thumbs-down": ThumbsDown,
    "thumbs-up": ThumbsUp,
    ticket: Ticket,
    "ticket-check": TicketCheck,
    "ticket-minus": TicketMinus,
    "ticket-percent": TicketPercent,
    "ticket-plus": TicketPlus,
    "ticket-slash": TicketSlash,
    "ticket-x": TicketX,
    tickets: Tickets,
    "tickets-plane": TicketsPlane,
    timeline: Timeline,
    timer: Timer,
    "timer-off": TimerOff,
    "timer-reset": TimerReset,
    "toggle-left": ToggleLeft,
    "toggle-right": ToggleRight,
    toilet: Toilet,
    "tool-case": ToolCase,
};

export default shard;
